export enum LogActions {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  RESTORE = 'RESTORE',
}

export const logActionsMap: Record<LogActions, string> = {
  CREATE: 'Criar',
  UPDATE: 'Atualizar',
  REMOVE: 'Remover',
  RESTORE: 'Restaurar',
}
